import * as React from 'react';

const SvgIconHoppedUp = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      d="M17.25 9.75h2.1a3.759 3.759 0 013.9 3.6v1.8a3.759 3.759 0 01-3.9 3.6h-2.1"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.25 8.256v13.6a1.372 1.372 0 01-1.35 1.394H5.1a1.373 1.373 0 01-1.35-1.393v-12.4M8.25 14.899v4.178M12.75 12.81v6.267"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M19.365 5.1a3.43 3.43 0 00-5.2-1.9 4.047 4.047 0 00-7.584.4 3.431 3.431 0 10-2.83 5.856h.007A3.37 3.37 0 007.39 12.74a3.472 3.472 0 002.69-1.829c.228-.399.368-.842.41-1.3a1.484 1.484 0 011.488-1.359c1.743 0 3.705.007 5.278 0A2.213 2.213 0 0019.5 6.21a3.528 3.528 0 00-.135-1.11z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIconHoppedUp;
